
export const RQ_GET_ALL_PRODUCTION_API = {
  url: 'api/production/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_PRODUCTION_BY_IDS_API = {
  url: 'api/product/<%= id %>/lookup',
  method: 'GET',
  auth: true,
};

export const RQ_PUT_PRODUCTION_API = {
  url: 'api/production/register',
  method: 'POST',
  auth: true,
};

export const RQ_UPDATE_PRODUCTION_API = {
  url: 'api/production/<%= id %>/update/allfields',
  method: 'PUT',
  auth: true,
};

export const RQ_PRODUCTION_BY_FILTER_API = {
  url: 'api/production/lookup/byfilter',
  method: 'POST',
  auth: false,
  Search:false,
};

export const RQ_DELETE_PRODUCTION_API = {
  url: 'api/production/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};

/* --- STAGE 1 BATCH PRODUCTION CONSTANTS --- */
export const RQ_CREATE_BATCH_API = {
  url: 'api/production/batch/create',
  method: 'POST',
  auth: true,
};

export const RQ_GET_AVAILABLE_BATCHES_API = {
  url: 'api/production/batch/available',
  method: 'GET',
  auth: true,
};

export const RQ_CANCEL_BATCH_API = {
  url: 'api/production/batch/<%= id %>/cancel',
  method: 'DELETE',
  auth: true,
};
